/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Gender_LabelInputs */

const en_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const fr_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const de_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht`)
};

const it_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genere`)
};

const ru_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пол`)
};

const es_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

const zh_cn2_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性别`)
};

const ja_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性別`)
};

const hi_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंग`)
};

const pt_pt2_voice_manager_gender_label = /** @type {(inputs: Voice_Manager_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gênero`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {Voice_Manager_Gender_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_gender_label = /** @type {((inputs?: Voice_Manager_Gender_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Gender_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_gender_label(inputs)
	if (locale === "de") return de_voice_manager_gender_label(inputs)
	if (locale === "it") return it_voice_manager_gender_label(inputs)
	if (locale === "ru") return ru_voice_manager_gender_label(inputs)
	if (locale === "es") return es_voice_manager_gender_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_gender_label(inputs)
	if (locale === "ja") return ja_voice_manager_gender_label(inputs)
	if (locale === "hi") return hi_voice_manager_gender_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_gender_label(inputs)
	return en_voice_manager_gender_label(inputs)
});